import axios from 'axios';
import { DASHBOARD_API } from './service';

export const createLeadershipQuote = (payload: any) => {
    const url = `${DASHBOARD_API}/quotes/leadership`;
    const response = axios.post(url, payload);
    return response;
};
